import {checkCaptcha} from '../../../helpers/forms'


const forbiddenSymbols = `!"№';:%?*()_@`

export const required = value => value ? undefined : 'Required'

export const maxLength = max => value =>
    value && value.length > max ? `Maximum characters: ${max}` : undefined;

export const minLength = min => value =>
    value && value.length < min ? `Minimum characters: ${min}` : undefined;

export const number = value =>
    value && isNaN(Number(value)) ? 'Must be a number' : undefined;

export const minValue = min => value =>
    value && value < min ? `Must be at least ${min}` : undefined;

export const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? 'Invalid email address'
        : undefined;

export const tooOld = value =>
    value && value > 65 ? 'You might be too old for this' : undefined;

export const aol = value =>
    value && /.+@aol\.com/.test(value)
        ? 'Really? You still use AOL for your email?'
        : undefined;

export const alphaNumeric = value =>
    value && /[^a-zA-Z0-9 ]/i.test(value)
        ? 'Only alphanumeric characters'
        : undefined;

export const phoneNumber = value =>
    value && !/^(0|[1-9][0-9]{9})$/i.test(value)
        ? 'Invalid phone number, must be 10 digits'
        : undefined;

export const youtube = value => value.search(/^(?:(?:https?:)?\/\/)?(?:www\.)?(?:m\.)?(?:youtu(?:be)?\.com\/(?:v\/|embed\/|watch(?:\/|\?v=))|youtu\.be\/)((?:\w|-){11})(?:\S+)?$/) === -1 ? "Only YouTube links" : undefined

const _getForbiddenSymbolsPattern = () => {
    const forbiddenSymbols = `!"'№;:%?*()_@`
    let symbols = forbiddenSymbols.split('')
    let pattern = ''
    symbols.forEach(s => {
        pattern += `\\${s}`
    })
    return new RegExp(`[${pattern}]`, 'gi')
}

export const excludeSymbols = value => {
    return value.search(_getForbiddenSymbolsPattern()) !== -1 ? `nameForbiddenSymbols` : undefined
}

export const captcha = (value, allValues, props) => {
    const {captchaHash} = props
    let errMsg = `The verification code is incorrect.`
    return (captchaHash && value && !checkCaptcha(value, captchaHash)) ? errMsg : undefined
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Form/rules.js